import {Component, OnInit, OnDestroy, Output, EventEmitter} from '@angular/core';
import {Subscription} from 'rxjs';
import {OAuthService} from '../shared/services/authorization/oauth.service';
import {SessionStorageService} from '../shared/services/session-storage.service';
import {PermissionService} from '../shared/services/permission.service';
import {Permissions} from '../shared/models/permissions.model';
import {RawPermissions} from '../shared/models/raw-permissions.model';
import {AppConfig} from '../app-config';
import {shouldUseAppConfigForEnvironment} from '../shared/helpers/environments';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {

  @Output() public logoutNotification: EventEmitter<any> = new EventEmitter();

  public username: string;
  public isMainHeaderNarrow = false;
  public logoutIsWaiting = false;
  public isLoggedIn  = true;

  private usernameSubscription: Subscription;

  public permissions: Permissions;

  public companies: Array<string>;
  public rawPermissions: Array<RawPermissions>;
  public rawPermissionsSubscription: Subscription;
  public isHidden = true;

  private webDirectUrl: string;

  @Output() public toggleMenu: EventEmitter<any> = new EventEmitter();
  @Output() public detectMobileSize: EventEmitter<any> = new EventEmitter();

  constructor(private appConfig: AppConfig,
              private sessionStorage: SessionStorageService,
              private oauthService: OAuthService,
              private permissionService: PermissionService) {
    if (shouldUseAppConfigForEnvironment(appConfig && appConfig.config && appConfig.config.environment)) {
      this.webDirectUrl = appConfig.config.webDirectUrl;
    } else {
      this.webDirectUrl = environment.webDirectUrl;
    }
  }

  ngOnInit(): void {
    this.usernameSubscription = this.sessionStorage.usernameChange.subscribe((username) => {
      this.username = username;
    });

    this.permissionService.permissions$.subscribe((permissions: Permissions) => {
      if (permissions) {
        this.permissions = permissions;
      }
    });

    this.rawPermissionsSubscription = this.permissionService.rawPermissions$.subscribe(rawPermissions => {
      if (rawPermissions) {
        this.rawPermissions = rawPermissions;
        this.companies = rawPermissions.map(el => el.companyName);
        this.isHidden = this.companies.length === 1;
      }
    });
  }

  ngOnDestroy(): void {
    this.usernameSubscription.unsubscribe();
  }

  public toggleDropdown() {
    this.toggleMenu.emit();
  }

  public checkForMobileBrowser() {
    this.detectMobileSize.emit();
  }

  public displayNarrowMainHeader(event) {
    this.isMainHeaderNarrow = event;
  }

  public logout() {
    this.logoutIsWaiting = true;
    this.oauthService.signOut();
  }

  navToWebDirect() {
    window.open(this.webDirectUrl, '_blank');
  }

  processLogout() {
    this.logoutNotification.emit();
  }
}
